import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TitleRow from './TitleRow';
import { terms } from '../constants/agentMovement';
import { useSearchStore } from '../../store/store';
import Loader from '@lwt-helix/loader';
import { NoResultsMessage } from '../../common/components/search/NoResultsMessage';
import { getExportButton } from '../../common/helpers/export';
import { exportButtonTypes } from '../../common/constants/export';
import { exportTypes } from './helpers/export';
import { AgentMovementResults } from './AgentMovementResults';
import { modules } from '../../constants';
import { useTable } from './hooks/table';
import { csvExportDateFormat } from '../helpers/dataFormatters';
import { useChart } from './hooks/chart';
import { usePDFStore } from '../../store/pdf/store';

const AgentMovement = ({agentData}) => {
    const results = agentData?.results;
    const agentsPerMonth = agentData?.agentsPerMonth;
    const {
        isLoading,
		selectedModule,
        savedSearchTitle,
        loadedSearchCriteria,
    } = useSearchStore(state => {
        const { isLoading, selectedModule } = state;
        const moduleState = state[selectedModule];
        const loadedSearchCriteria = moduleState?.loadedSearchCriteria;
        const savedSearchTitle = moduleState?.selectedSavedSearch?.savedSearch?.searchName;
        return ({
            isLoading,
			selectedModule,
            savedSearchTitle,
            loadedSearchCriteria,
        });
    });

    const {
        setColumnDefs,
        setResults,
    } = usePDFStore(state => ({
        setColumnDefs: state.setColumnDefs,
        setResults: state.setResults,
    }));

    const [state, setState] = useState({
        selectedPeriod: terms.last365Days,
        shouldDisplayMetricsPopover: false,
    });

    const tableProps = useTable(results);
    const chartProps = useChart(agentsPerMonth);

    useEffect(() => {
        setColumnDefs(tableProps.tableView.tables);
        setResults(agentData?.results);
    }, [agentData])

    const loader = <div className='py-3'><Loader /></div>;
    const hasResults = selectedModule === modules.proficiencyMetrics.agentMovement &&
        results?.length > 0;

    const exportDetails = {
        exportType: exportTypes.searchResults,
        listingType: 'agents',
        listingStatus: '',
        date: csvExportDateFormat(new Date),
    };

    const exportButton = getExportButton({
        exportDetails,
        shouldUsePrimaryColumns: true,
        gridRef: tableProps.gridRef,
        type: exportButtonTypes.secondary,
        isDisabled: isLoading
    });

    const titleRowProps = {
        hasResults,
        selectedPeriod: state.selectedPeriod,
        setState,
        shouldDisplayMetricsPopover: state.shouldDisplayMetricsPopover,
        exportButton,
        savedSearchTitle,
        loadedSearchCriteria,
    };

    const getStatusMessage = ({ messageContent }) => (<>
        <TitleRow {...titleRowProps} />
        <div className="text-center"> {messageContent} </div>
    </>);

    const initialSearchNotRun = getStatusMessage({
        messageContent: <p className="initial-search"> {terms.searchFilterAdjust} </p>
    });

    if (isLoading) return loader;

    if (!hasResults && !!results) return getStatusMessage({ messageContent: <NoResultsMessage /> });

    if (hasResults && !!loadedSearchCriteria) return <AgentMovementResults
        titleRowProps={titleRowProps}
        tableProps={tableProps}
        chartProps={chartProps}
    />;

    return <>{initialSearchNotRun}</>;
};

AgentMovement.propTypes = {
    agentData: PropTypes.shape({
        results: PropTypes.array,
        agentsPerMonth: PropTypes.array,
    }),
};

export default AgentMovement;
